import { DeviceModelResponseDto } from "@/entities/device-model/types";
import { org_NewYorkHospital, org_PlovdivHospital, org_SofiaHospital, org_MadridHospital } from "./organizations.mock";

const appConfig = "arn:aws:ecs:us-east-1:381492204705:task-definition/rta-smart-rea:4";
const appConfig2 = "arn:aws:ecs:us-east-2:381492204705:task-definition/rta-smart-rea:4";
const applicationConfig = "{\"ruleFiles\": [\"s3://rta-artifactbucket-381492204705-us-east-1/DROOLS-RULES/DRSAlgo.drl\",\"s3://rta-artifactbucket-381492204705-us-east-1/DROOLS-RULES/CVP.drl\",\"s3://rta-artifactbucket-381492204705-us-east-1/DROOLS-RULES/Pressure.drl\",\"s3://rta-artifactbucket-381492204705-us-east-1/DROOLS-RULES/SageMakerExec.drl\",\"s3://rta-artifactbucket-381492204705-us-east-1/DROOLS-RULES/DroolsHelper.drl\"], \"dataConsumerStartOffset\": \"earliest\"}";
const defaultFactorySettings = [
    { name: "SpO2 threshold", required: false, onlyEditableAtPolicyLevel: false, type: 'Number' as const, defaultValue: 90, unit: '%', min: 80, max: 100, step: 1 },
    { name: "Delay", required: false, onlyEditableAtPolicyLevel: true, type: 'Number' as const, defaultValue: 35, unit: 'seconds', min: 25, max: 38, step: 1 },
    { name: "Enable safety checks", required: false, onlyEditableAtPolicyLevel: true, type: 'Boolean' as const, defaultValue: true },
    { name: "Display color", required: false, onlyEditableAtPolicyLevel: true, type: 'Enum' as const, enumOptions: ['Blue', 'Red', 'Green'], defaultValues: ['Green'], allowMultipleSelection: false },
    { name: "Display label", required: false, onlyEditableAtPolicyLevel: true, type: 'String' as const, defaultValue: 'DRS', minLength: 1, maxLength: 20, pattern: null },
];

export const dm_DRSAlgo1: DeviceModelResponseDto = {
    id: "dc19e3f8-a3a1-4eb0-8603-b85a10d2fe2d",
    organizationId: org_NewYorkHospital.organizationId,
    name: "DRSAlgo 1", version: "1.0", deviceType: "Other", description: "TEST", status: "Draft", visibility: 'Public',
    application: appConfig, applicationConfig, factorySettings: defaultFactorySettings,
    measurements: [], alerts: [], availCountryCodes: ['BG', 'US'], entitlements: 0,
    isRegulated: true, identifier: null
};

export const dm_DRSAlgo2: DeviceModelResponseDto = {
    id: "0fb893fb-3961-4ffe-96c6-617225dc74b4",
    organizationId: org_MadridHospital.organizationId,
    name: "DRSAlgo 2", version: "1.0", deviceType: "Other", description: "TEST", status: "Draft", visibility: 'Private',
    application: appConfig, applicationConfig, factorySettings: defaultFactorySettings,
    measurements: [], alerts: [], availCountryCodes: ['BG', 'ES'], entitlements: 0,
    isRegulated: true, identifier: null
};

export const dm_DRSAlgo3: DeviceModelResponseDto = {
    id: "e9e7e9c2-0bbc-4e91-ab5c-5ae8c3169129",
    organizationId: org_MadridHospital.organizationId,
    name: "DRSAlgo 3", version: "1.0", deviceType: "Other", description: "TEST", status: "Draft", visibility: 'Public',
    application: appConfig2, applicationConfig, factorySettings: defaultFactorySettings,
    measurements: [], alerts: [], availCountryCodes: ['BG', 'US'], entitlements: 0,
    isRegulated: true, identifier: null
};

export const dm_DRSAlgo4: DeviceModelResponseDto = {
    id: "0659f344-9c0f-444e-a583-22ad7263dfe9",
    organizationId: org_PlovdivHospital.organizationId,
    name: "DRSAlgo 4", version: "1.0", deviceType: "Other", description: "TEST", status: "Draft", visibility: 'Private',
    application: appConfig, applicationConfig, factorySettings: defaultFactorySettings,
    measurements: [], alerts: [], availCountryCodes: ['GB', 'US'], entitlements: 0,
    isRegulated: true, identifier: null
};

export const dm_DRSAlgo5: DeviceModelResponseDto = {
    id: "ddcd1658-9919-4572-9ebf-9db2f06650b1",
    organizationId: org_PlovdivHospital.organizationId,
    name: "DRSAlgo 5", version: "1.0", deviceType: "Other", description: "TEST", status: "Draft", visibility: 'Public',
    application: appConfig2, applicationConfig, factorySettings: defaultFactorySettings,
    measurements: [], alerts: [], availCountryCodes: ['GB', 'US'], entitlements: 0,
    isRegulated: false, identifier: null
};

export const dm_DRSAlgo6: DeviceModelResponseDto = {
    id: "0659f344-9c0f-444e-a583-22ad7263dfe1",
    organizationId: org_SofiaHospital.organizationId,
    name: "DRSAlgo 6", version: "1.0", deviceType: "Other", description: "TEST", status: "Pending", visibility: 'Private',
    application: appConfig, applicationConfig, factorySettings: defaultFactorySettings,
    measurements: [], alerts: [], availCountryCodes: ['GB', 'ES'], entitlements: 0,
    isRegulated: false, identifier: null
};

export const dm_DRSAlgo7: DeviceModelResponseDto = {
    id: "ddcd1658-9919-4572-9ebf-9db2f06650b2",
    organizationId: org_SofiaHospital.organizationId,
    name: "DRSAlgo 7", version: "1.0", deviceType: "Other", description: "TEST", status: "Released", visibility: 'Public',
    application: appConfig2, applicationConfig,
    factorySettings: defaultFactorySettings,
    measurements: [], alerts: [], availCountryCodes: ['AT', 'AU'], entitlements: 0,
    isRegulated: false, identifier: "0659f344-9c0f-444e-a583-22ad7263dfe1"
};

export const deviceModelsMock: DeviceModelResponseDto[] = [
    dm_DRSAlgo1, dm_DRSAlgo2, dm_DRSAlgo3,
    dm_DRSAlgo4, dm_DRSAlgo5,
    dm_DRSAlgo6, dm_DRSAlgo7,
];

